import { render, staticRenderFns } from "./Workshop-Club-List.vue?vue&type=template&id=8306bf80&scoped=true"
import script from "./Workshop-Club-List.vue?vue&type=script&lang=js"
export * from "./Workshop-Club-List.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8306bf80",
  null
  
)

export default component.exports